import type { ReactElement, SVGProps } from "react";

export function ShieldIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width="13"
      height="17"
      viewBox="0 0 13 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.58333 10.9423L10.1731 6.3525L9.20354 5.38292L5.58333 9.00313L3.73875 7.15854L2.76917 8.12813L5.58333 10.9423ZM6.45833 16.3204C4.60361 15.8236 3.06354 14.7365 1.83813 13.0592C0.612709 11.3818 0 9.49347 0 7.39417V2.42937L6.45833 0L12.9167 2.42937V7.39417C12.9167 9.49347 12.304 11.3818 11.0785 13.0592C9.85312 14.7365 8.31306 15.8236 6.45833 16.3204Z"
        fill="#128351"
      />
    </svg>
  );
}
